import React from 'react';

import styles from './Link.module.scss';

export default function Link({ title, className, titleClassName, onClick }) {
	return (
		<div className={`${styles.container} ${className}`} onClick={onClick}>
			<p className={`${styles.title} ${titleClassName}`}>{title}</p>
		</div>
	);
}
